module.exports = __webpack_public_path__ + "img/sentra_makmur.c5293fdd.png";